module.exports = __webpack_public_path__ + "img/notary_hov_pre_img.f7044ea7.png";